export default __webpack_public_path__ + "static/media/ic_down.316de1ef.svg";